/** @type {import("../../../../shared/ui/data-table/model/data-table-contract").UnifiedTableRecord[]} */
export const allergies = [
  {
    patientId: "10",
    module: "allergies",
    pageTitle: "Allergies",

    subnav: [],

    sections: [
      {
        id: "problem-list-history",
        title: "Problem List & History",
        tables: [
          {
            id: "problems-main",
            columns: [
              { key: "agent", header: "Agent", sortable: true },
              { key: "reaction", header: "Reaction" },
              { key: "onsetDate", header: "Onset Date" },
              { key: "provider", header: "Provider" },
            ],
            rows: [
              {
                agent: "Penicillin",
                reaction: "Rash",
                onsetDate: "06/07/2013",
                provider: "Dr. John Smith",
              },
              {
                agent: "Peanuts",
                reaction: "Anaphylaxis",
                onsetDate: "10/06/2017",
                provider: "Dr. Emily Davis",
              },
              {
                agent: "Latex",
                reaction: "Contact Dermatitis",
                onsetDate: "02/18/2010",
                provider: "Dr. Robert Lee",
              },
              {
                agent: "Amoxicillin",
                reaction: "Diarrhea",
                onsetDate: "05/19/2009",
                provider: "Dr. Nancy White",
              },
              {
                agent: "Sulfa Drugs",
                reaction: "Hives",
                onsetDate: "03/14/2015",
                provider: "Dr. Aaron Patel",
              },
              {
                agent: "Shellfish",
                reaction: "Swelling",
                onsetDate: "09/21/2018",
                provider: "Dr. Maria Gomez",
              },
              {
                agent: "Ibuprofen",
                reaction: "Shortness of breath",
                onsetDate: "01/12/2020",
                provider: "Dr. Helen Brooks",
              },
              {
                agent: "Contrast Dye",
                reaction: "Nausea",
                onsetDate: "07/03/2021",
                provider: "Dr. David Kim",
              },
              {
                agent: "Bee Stings",
                reaction: "Localized swelling",
                onsetDate: "04/18/2012",
                provider: "Dr. Olivia Turner",
              },
              {
                agent: "Aspirin",
                reaction: "Gastrointestinal upset",
                onsetDate: "11/08/2019",
                provider: "Dr. Peter Hall",
              },
            ],
            ui: {
              searchable: true,
              searchPlaceholder: "Search...",
              searchKeys: ["agent", "reaction", "onsetDate", "provider"],
              downloadable: ["csv", "xls", "pdf"],
              downloadLinks: {
                csv: "https://drive.google.com/uc?export=download&id=1c8I5BtCb_DVj1RcCbdjyZv89InXC3riu",
                pdf: "https://drive.google.com/uc?export=download&id=1OrzhC4cpp7BATzvDfZKcoVmwDfxXRLxV",
                xls: "https://docs.google.com/spreadsheets/d/1nM41ox0vRDoTBjCuSxFGusbbyp1ZOiD0/export?format=xlsx",
              },
              defaultRowsPerPage: 10,
              rowsPerPageOptions: [5, 10, 20, 25],
            },
          },
        ],
      },
    ],
  },

  {
    patientId: "11",
    module: "allergies",
    pageTitle: "Allergies",

    subnav: [],

    sections: [
      {
        id: "problem-list-history",
        title: "Problem List & History",
        tables: [
          {
            id: "problems-main",
            columns: [
              { key: "agent", header: "Agent", sortable: true },
              { key: "reaction", header: "Reaction" },
              { key: "onsetDate", header: "Onset Date" },
              { key: "provider", header: "Provider" },
            ],
            rows: [
              {
                agent: "Penicillin",
                reaction: "Rash",
                onsetDate: "10/06/2017",
                provider: "Dr. John Smith",
              },
              {
                agent: "Peanuts",
                reaction: "Anaphylaxis",
                onsetDate: "06/07/2013",
                provider: "Dr. Emily Davis",
              },
              {
                agent: "Latex",
                reaction: "Contact Dermatitis",
                onsetDate: "02/18/2010",
                provider: "Dr. Robert Lee",
              },
              {
                agent: "Amoxicillin",
                reaction: "Diarrhea",
                onsetDate: "05/19/2009",
                provider: "Dr. Nancy White",
              },
              {
                agent: "Sulfa Drugs",
                reaction: "Hives",
                onsetDate: "03/14/2015",
                provider: "Dr. Aaron Patel",
              },
              {
                agent: "Shellfish",
                reaction: "Swelling",
                onsetDate: "09/21/2018",
                provider: "Dr. Maria Gomez",
              },
              {
                agent: "Ibuprofen",
                reaction: "Shortness of breath",
                onsetDate: "01/12/2020",
                provider: "Dr. Helen Brooks",
              },
              {
                agent: "Contrast Dye",
                reaction: "Nausea",
                onsetDate: "07/03/2021",
                provider: "Dr. David Kim",
              },
              {
                agent: "Bee Stings",
                reaction: "Localized swelling",
                onsetDate: "04/18/2012",
                provider: "Dr. Olivia Turner",
              },
              {
                agent: "Aspirin",
                reaction: "Gastrointestinal upset",
                onsetDate: "11/08/2019",
                provider: "Dr. Peter Hall",
              },
            ],
            ui: {
              searchable: true,
              searchPlaceholder: "Search...",
              searchKeys: ["agent", "reaction", "onsetDate", "provider"],
              downloadable: ["csv", "xls", "pdf"],
              downloadLinks: {
                csv: "https://drive.google.com/uc?export=download&id=1c8I5BtCb_DVj1RcCbdjyZv89InXC3riu",
                pdf: "https://drive.google.com/uc?export=download&id=1OrzhC4cpp7BATzvDfZKcoVmwDfxXRLxV",
                xls: "https://docs.google.com/spreadsheets/d/1nM41ox0vRDoTBjCuSxFGusbbyp1ZOiD0/export?format=xlsx",
              },
              defaultRowsPerPage: 10,
              rowsPerPageOptions: [5, 10, 20, 25],
            },
          },
        ],
      },
    ],
  },
];
